import React from 'react';
import { Trans } from '@lingui/react';
import { Weaken } from 'utils';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';

import { BetweenNodesRow } from '../../types';

interface BetweenNodesTableProps {
  betweenNodesData: Weaken<BetweenNodesRow>;
  hasError?: (field: string) => boolean;
  getErrorHelpText?: (field: string) => string;
  handleBetweenNodesChange?: (field: string, value: any) => void;
}

const BetweenNodesTable: React.FC<BetweenNodesTableProps> = ({
  betweenNodesData,
  hasError = () => false,
  getErrorHelpText = () => '',
  handleBetweenNodesChange = () => { },
}) => {
  const getFieldErrorText = (fieldName: string) => {
    if (hasError(fieldName)) {
      return getErrorHelpText(fieldName);
    }
    return '';
  };

  return (
    <TableContainer component={Paper} sx={{ '& .MuiTable-root': { tableLayout: 'fixed' } }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              <Trans id="Node ID*">Node ID*</Trans>
            </TableCell>
            <TableCell>
              <TextField
                fullWidth
                value={betweenNodesData.nodeId || ''}
                onChange={(e) => handleBetweenNodesChange('nodeId', e.target.value)}
                size="small"
                error={hasError('nodeId')}
                required
                helperText={getFieldErrorText('nodeId')}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BetweenNodesTable;
